webpackJsonp([61585639395791],{

/***/ 1771:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EncounterSectionDatum","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"encounter","type":{"kind":"OBJECT","name":"Encounter","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-encounter-section-datum-6ea7e811d2b268de00bc.js